import { render } from "./ComponentTurnstile.vue?vue&type=template&id=a89375ea&scoped=true"
import script from "./ComponentTurnstile.vue?vue&type=script&lang=js"
export * from "./ComponentTurnstile.vue?vue&type=script&lang=js"

import "./ComponentTurnstile.vue?vue&type=style&index=0&id=a89375ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89375ea"]])

export default __exports__